(() => {
  if (customElements.get('complete-the-look-product')) return;

  class CompleteTheLookProduct extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        sizeSelect: '[data-size-select]',
        variantsData: '[data-variants]',
        variantInput: '[name="id"]',
        priceElement: '[data-price]',
        addButton: '[data-add-btn]'
      };
      this.buttonText = {
        add: window.variantStrings?.addToCart || 'Add to shopping bag',
        unavailable: window.variantStrings?.unavailable || 'Unavailable',
        soldOut: window.variantStrings?.soldOut || 'Sold out',
        selectSize: window.variantStrings?.selectSize || 'Select a size'
      };
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector(this.selectors.addButton);
      this.sizeSelect = this.querySelector(this.selectors.sizeSelect);
      this.lockedColor = this.dataset.lockedColor;
      this.colorOptionIndex = parseInt(this.dataset.colorOptionIndex, 10);
      this.sizeOptionIndex = parseInt(this.dataset.sizeOptionIndex, 10);

      const variantsScript = this.querySelector(this.selectors.variantsData);
      this.variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];

      this.updateCurrentVariant();
      this.updateButtonState();
      this.setHandlers();
    }

    updateCurrentVariant() {
      // No size selector — use first available variant
      if (!this.sizeSelect) {
        this.currentVariant = this.variants.find(v => v.available) || this.variants[0];
        this.syncVariantInput();
        return;
      }

      const selectedSize = this.sizeSelect.value;

      // No size selected yet (placeholder selected)
      if (!selectedSize) {
        this.currentVariant = null;
        return;
      }

      // Find variant matching selected size at the known size option index
      this.currentVariant = this.variants.find(v => {
        return v.options[this.sizeOptionIndex] === selectedSize;
      });

      this.syncVariantInput();
    }

    syncVariantInput() {
      if (!this.currentVariant || !this.form) return;
      const input = this.form.querySelector(this.selectors.variantInput);
      if (input) input.value = this.currentVariant.id;
    }

    updateButtonState() {
      if (!this.submitButton) return;
      const span = this.submitButton.querySelector('span');

      // Size not selected yet
      if (this.sizeSelect && !this.sizeSelect.value) {
        this.submitButton.setAttribute('disabled', 'disabled');
        return;
      }

      // No matching variant
      if (!this.currentVariant) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (span) span.textContent = this.buttonText.unavailable;
        return;
      }

      // Variant out of stock
      if (!this.currentVariant.available) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (span) span.textContent = this.buttonText.soldOut;
        return;
      }

      // Available
      this.submitButton.removeAttribute('disabled');
      if (span) span.textContent = this.buttonText.add;
    }

    setHandlers() {
      if (this.form) {
        this.form.addEventListener('submit', this.onFormSubmit.bind(this));
      }

      if (this.sizeSelect) {
        this.sizeSelect.addEventListener('change', this.onSizeChange.bind(this));
      }
    }

    onSizeChange() {
      this.updateCurrentVariant();
      this.updateButtonState();
    }

    onFormSubmit(event) {
      event.preventDefault();
      if (this.submitButton.hasAttribute('disabled')) return;

      if (typeof addToCart !== 'function') {
        console.error('complete-the-look: addToCart is not defined');
        return;
      }

      const cartDrawer = document.querySelector('cart-drawer');
      const span = this.submitButton.querySelector('span');

      this.submitButton.setAttribute('disabled', 'disabled');
      if (span) span.textContent = '...';

      const sections = cartDrawer
        ? cartDrawer.getSectionsToRender().map(s => s.section)
        : null;

      addToCart(this.form, sections)
        .then(response => {
          if (response.status) {
            if (span) span.textContent = response.description || 'Error';
            return;
          }
          if (cartDrawer) cartDrawer.renderContents(response);
        })
        .catch(err => {
          console.error(err);
          if (span) span.textContent = 'Error';
        })
        .finally(() => {
          setTimeout(() => this.updateButtonState(), 2000);
        });
    }
  }

  customElements.define('complete-the-look-product', CompleteTheLookProduct);
})();
